import { extraLoyaltyPayoutEligibleCategory } from '@zet/feature-brands/utils/constants'
import _ from 'lodash'

import { useLoyaltyPayout } from '../../api/common/hooks/useLoyaltyPayout'

type useLoyaltyPayoutMetaProps = {
  partnerId?: number | string
  partnerCategoryId?: string | number
  isHighestLoyaltyPayout?: boolean
  isAllLevelPayout?: boolean
  isUserCurrentTierPayout?: boolean
  payoutContent?: string | number
  categoryId?: string | number
}

export const useLoyaltyPayoutMeta = ({
  partnerId,
  partnerCategoryId,
  isHighestLoyaltyPayout,
  isAllLevelPayout,
  isUserCurrentTierPayout,
  payoutContent,
  categoryId,
}: useLoyaltyPayoutMetaProps) => {
  const {
    data: loyaltyPayout = {},
    isLoading: loyaltyPayoutLoading,
    isError: loyaltyPayoutError,
  } = useLoyaltyPayout({
    partnerId,
    ...(partnerCategoryId && { partnerCategoryId: partnerCategoryId }),
    ...(isHighestLoyaltyPayout && { isHighestLoyaltyPayout: true }),
    ...(isUserCurrentTierPayout && { isUserCurrentTierPayout: true }),
    ...(isAllLevelPayout && { isAllLevelPayout: true }),
  })

  const basePayoutValue = parseFloat(payoutContent?.replace(/[^0-9.]/g, ''))
  const isPercentagePayout = payoutContent?.toString().includes('%')
  const extractedPayoutValue = parseFloat(
    payoutContent?.replace(/[^0-9.]/g, '')
  )
  const isEligibleForLoyaltyPayout =
    extraLoyaltyPayoutEligibleCategory.includes(categoryId?.toString())

  function computeHighestPayout() {
    if (isPercentagePayout) {
      if (_.isEmpty(loyaltyPayout)) {
        return basePayoutValue + '%'
      } else {
        return (basePayoutValue + loyaltyPayout?.payout).toFixed(2) + '%'
      }
    } else {
      if (_.isEmpty(loyaltyPayout)) {
        return '₹' + basePayoutValue
      }
      return '₹' + (basePayoutValue + loyaltyPayout?.payout)
    }
  }
  function handleCoinsColumn() {
    if (isPercentagePayout) return true
    else if (basePayoutValue >= 250) return true
    else return false
  }
  function handleExtraPayoutColumn() {
    if (!_.isEmpty(loyaltyPayout) && isEligibleForLoyaltyPayout) return true
    else return false
  }

  function getPayoutText() {
    if (isPercentagePayout) {
      return loyaltyPayout?.payout + '%'
    } else {
      return '₹' + loyaltyPayout?.payout
    }
  }
  return {
    loyaltyPayoutError,
    isPercentagePayout,
    basePayoutValue,
    loyaltyPayout,
    loyaltyPayoutLoading,
    extractedPayoutValue,
    computeHighestPayout,
    handleCoinsColumn,
    handleExtraPayoutColumn,
    getPayoutText,
  }
}
